import {SectionIntro, Section} from '@primer/react-brand'
import type {FeaturedContentProps} from './types'
import {renderWithNoMarks} from '../../../utils'
import {FlexSuiteRiverAccordion} from '../../../components/FlexSuiteRiverAccordion'
import {FlexSuiteRiverStack} from '../../../components/FlexSuiteRiverStack'
import {FlexSuiteRiverBreakout} from '../../../components/FlexSuiteRiverBreakout'

const FeaturedContent = ({
  featureHeading,
  featureLabel,
  featureDescription,
  featureLink,
  featureDetailsOne,
  featureRiverAccordion,
  featureRiverStack,
  featureDetailsTwo,
  featureRiverBreakout,
}: FeaturedContentProps) => {
  return (
    <Section>
      <SectionIntro align="center">
        {featureLabel && <SectionIntro.Label>{featureLabel}</SectionIntro.Label>}
        {featureHeading && <SectionIntro.Heading>{renderWithNoMarks(featureHeading)}</SectionIntro.Heading>}
        {featureDescription && (
          <SectionIntro.Description>{renderWithNoMarks(featureDescription)}</SectionIntro.Description>
        )}
        {featureLink?.fields.href && (
          <SectionIntro.Link href={featureLink.fields.href}>{featureLink.fields.text}</SectionIntro.Link>
        )}
      </SectionIntro>
      {featureDetailsOne === 'Accordion' && featureRiverAccordion && (
        <FlexSuiteRiverAccordion items={featureRiverAccordion} />
      )}
      {featureDetailsOne === 'Stack' && featureRiverStack && <FlexSuiteRiverStack items={featureRiverStack} />}
      {featureDetailsTwo === 'Breakout' && featureRiverBreakout && (
        <FlexSuiteRiverBreakout {...featureRiverBreakout.fields} />
      )}
    </Section>
  )
}
export {FeaturedContent}
